import { render, staticRenderFns } from "./iconify.vue?vue&type=template&id=d6f00658&"
import script from "./iconify.vue?vue&type=script&lang=js&"
export * from "./iconify.vue?vue&type=script&lang=js&"
import style0 from "./iconify.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports